import { css } from '@emotion/react';

type NoReviewsEmptyStateProps = {
  size?: number;
};

export const NoReviewsEmptyState = ({ size = 600 }: NoReviewsEmptyStateProps) => (
  <svg
    id='Layer_1'
    data-name='Layer 1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    viewBox='0 0 599.06 599.06'
    css={css`
      width: ${size}px;
      height: ${size}px;
      .cls-1 {
        clip-path: url(#clippath);
      }
      .cls-2 {
        fill: none;
      }
      .cls-2,
      .cls-3,
      .cls-4,
      .cls-5,
      .cls-6,
      .cls-7,
      .cls-8,
      .cls-9,
      .cls-10,
      .cls-11,
      .cls-12,
      .cls-13,
      .cls-14,
      .cls-15,
      .cls-16,
      .cls-17,
      .cls-18,
      .cls-19,
      .cls-20,
      .cls-21,
      .cls-22,
      .cls-23,
      .cls-24,
      .cls-25,
      .cls-26,
      .cls-27,
      .cls-28,
      .cls-29,
      .cls-30,
      .cls-31,
      .cls-32,
      .cls-33,
      .cls-34,
      .cls-35,
      .cls-36,
      .cls-37,
      .cls-38,
      .cls-39,
      .cls-40,
      .cls-41,
      .cls-42,
      .cls-43,
      .cls-44,
      .cls-45,
      .cls-46,
      .cls-47,
      .cls-48,
      .cls-49,
      .cls-50,
      .cls-51,
      .cls-52,
      .cls-53,
      .cls-54,
      .cls-55,
      .cls-56,
      .cls-57,
      .cls-58,
      .cls-59,
      .cls-60,
      .cls-61,
      .cls-62,
      .cls-63,
      .cls-64,
      .cls-65,
      .cls-66,
      .cls-67,
      .cls-68,
      .cls-69,
      .cls-70,
      .cls-71,
      .cls-72,
      .cls-73,
      .cls-74,
      .cls-75,
      .cls-76,
      .cls-77,
      .cls-78,
      .cls-79,
      .cls-80,
      .cls-81,
      .cls-82,
      .cls-83,
      .cls-84,
      .cls-85,
      .cls-86,
      .cls-87,
      .cls-88,
      .cls-89,
      .cls-90,
      .cls-91,
      .cls-92,
      .cls-93,
      .cls-94,
      .cls-95,
      .cls-96,
      .cls-97,
      .cls-98,
      .cls-99,
      .cls-100,
      .cls-101,
      .cls-102,
      .cls-103,
      .cls-104,
      .cls-105,
      .cls-106,
      .cls-107,
      .cls-108,
      .cls-109,
      .cls-110,
      .cls-111,
      .cls-112,
      .cls-113,
      .cls-114,
      .cls-115,
      .cls-116,
      .cls-117,
      .cls-118,
      .cls-119,
      .cls-120,
      .cls-121,
      .cls-122,
      .cls-123,
      .cls-124,
      .cls-125,
      .cls-126,
      .cls-127,
      .cls-128,
      .cls-129,
      .cls-130,
      .cls-131,
      .cls-132,
      .cls-133 {
        stroke-width: 0px;
      }
      .cls-134 {
        clip-path: url(#clippath-1);
      }
      .cls-135 {
        clip-path: url(#clippath-2);
      }
      .cls-3 {
        fill: #1c2964;
      }
      .cls-4 {
        fill: #dcebfe;
      }
      .cls-5 {
        fill: #9ec5ff;
      }
      .cls-6 {
        fill: #ffcb13;
      }
      .cls-7 {
        fill: #ffcb11;
      }
      .cls-8 {
        fill: #ffcb12;
      }
      .cls-9 {
        fill: #ffcb14;
      }
      .cls-10 {
        fill: #ffcb10;
      }
      .cls-11 {
        fill: #ffe37e;
      }
      .cls-12 {
        fill: #ffdc5f;
      }
      .cls-13 {
        fill: #ffdc60;
      }
      .cls-14 {
        fill: #ffdc61;
      }
      .cls-15 {
        fill: #ffdc62;
      }
      .cls-16 {
        fill: #ffdc5e;
      }
      .cls-17 {
        fill: #ffe380;
      }
      .cls-18 {
        fill: #ffe37f;
      }
      .cls-19 {
        fill: #fff;
      }
      .cls-20 {
        fill: #ffe27d;
      }
      .cls-21 {
        fill: #ffe27a;
      }
      .cls-22 {
        fill: #ffe27c;
      }
      .cls-23 {
        fill: #ffe27b;
      }
      .cls-24 {
        fill: #ffdb5b;
      }
      .cls-25 {
        fill: #ffdb5c;
      }
      .cls-26 {
        fill: #ffdb5a;
      }
      .cls-27 {
        fill: #ffdb5d;
      }
      .cls-28 {
        fill: #ffe178;
      }
      .cls-29 {
        fill: #ffe179;
      }
      .cls-30 {
        fill: #ffe177;
      }
      .cls-31 {
        fill: #ffe175;
      }
      .cls-32 {
        fill: #ffe176;
      }
      .cls-33 {
        fill: #ffda58;
      }
      .cls-34 {
        fill: #ffda55;
      }
      .cls-35 {
        fill: #ffda56;
      }
      .cls-36 {
        fill: #ffdf6d;
      }
      .cls-37 {
        fill: #ffdf6f;
      }
      .cls-38 {
        fill: #ffdf6c;
      }
      .cls-39 {
        fill: #ffdf6e;
      }
      .cls-40 {
        fill: #ffdf70;
      }
      .cls-41 {
        fill: #ffda57;
      }
      .cls-42 {
        fill: #ffda59;
      }
      .cls-43 {
        fill: #ffd953;
      }
      .cls-44 {
        fill: #ffd954;
      }
      .cls-45 {
        fill: #ffd951;
      }
      .cls-46 {
        fill: #ffd952;
      }
      .cls-47 {
        fill: #ffd02b;
      }
      .cls-48 {
        fill: #ffd027;
      }
      .cls-49 {
        fill: #ffd028;
      }
      .cls-50 {
        fill: #ffd02a;
      }
      .cls-51 {
        fill: #ffd029;
      }
      .cls-52 {
        fill: #ffcf23;
      }
      .cls-53 {
        fill: #ffcf24;
      }
      .cls-54 {
        fill: #ffcf25;
      }
      .cls-55 {
        fill: #ffcf26;
      }
      .cls-56 {
        fill: #ffd230;
      }
      .cls-57 {
        fill: #ffd231;
      }
      .cls-58 {
        fill: #ffd232;
      }
      .cls-59 {
        fill: #ffd335;
      }
      .cls-60 {
        fill: #ffd337;
      }
      .cls-61 {
        fill: #ffd338;
      }
      .cls-62 {
        fill: #ffd336;
      }
      .cls-63 {
        fill: #ffd12f;
      }
      .cls-64 {
        fill: #ffd12e;
      }
      .cls-65 {
        fill: #ffd12d;
      }
      .cls-66 {
        fill: #ffd12c;
      }
      .cls-67 {
        fill: #ffc804;
      }
      .cls-68 {
        fill: #ffc806;
      }
      .cls-69 {
        fill: #ffc805;
      }
      .cls-70 {
        fill: #ffc803;
      }
      .cls-71 {
        fill: #ffd234;
      }
      .cls-72 {
        fill: #ffd233;
      }
      .cls-73 {
        fill: #ffd647;
      }
      .cls-74 {
        fill: #ffd646;
      }
      .cls-75 {
        fill: #ffd643;
      }
      .cls-76 {
        fill: #ffd645;
      }
      .cls-77 {
        fill: #ffca0c;
      }
      .cls-78 {
        fill: #ffca0f;
      }
      .cls-79 {
        fill: #ffca0e;
      }
      .cls-80 {
        fill: #ffca0d;
      }
      .cls-81 {
        fill: #ffd644;
      }
      .cls-82 {
        fill: #ffce1e;
      }
      .cls-83 {
        fill: #ffce1f;
      }
      .cls-84 {
        fill: #ffce22;
      }
      .cls-85 {
        fill: #ffcd19;
      }
      .cls-86 {
        fill: #ffcd1b;
      }
      .cls-87 {
        fill: #ffcd1a;
      }
      .cls-88 {
        fill: #ffd84c;
      }
      .cls-89 {
        fill: #ffc907;
      }
      .cls-90 {
        fill: #ffd84d;
      }
      .cls-91 {
        fill: #ffd53f;
      }
      .cls-92 {
        fill: #ffd53e;
      }
      .cls-93 {
        fill: #ffd43d;
      }
      .cls-94 {
        fill: #ffd43b;
      }
      .cls-95 {
        fill: #ffcd1d;
      }
      .cls-96 {
        fill: #ffcd1c;
      }
      .cls-97 {
        fill: #ffd541;
      }
      .cls-98 {
        fill: #ffd542;
      }
      .cls-99 {
        fill: #ffcc15;
      }
      .cls-100 {
        fill: #ffc702;
      }
      .cls-101 {
        fill: #ffc700;
      }
      .cls-102 {
        fill: #ffc701;
      }
      .cls-103 {
        fill: #ffd43c;
      }
      .cls-104 {
        fill: #ffd748;
      }
      .cls-105 {
        fill: #ffd74b;
      }
      .cls-106 {
        fill: #ffd74a;
      }
      .cls-107 {
        fill: #ffd749;
      }
      .cls-108 {
        fill: #ffce21;
      }
      .cls-109 {
        fill: #ffce20;
      }
      .cls-110 {
        fill: #ffc909;
      }
      .cls-111 {
        fill: #ffcc16;
      }
      .cls-112 {
        fill: #ffd84f;
      }
      .cls-113 {
        fill: #ffd850;
      }
      .cls-114 {
        fill: #ffc908;
      }
      .cls-115 {
        fill: #ffcc17;
      }
      .cls-116 {
        fill: #ffcc18;
      }
      .cls-117 {
        fill: #ffd84e;
      }
      .cls-118 {
        fill: #ffd43a;
      }
      .cls-119 {
        fill: #ffd439;
      }
      .cls-120 {
        fill: #ebf3ff;
      }
      .cls-121 {
        fill: #ffde6b;
      }
      .cls-122 {
        fill: #ffde68;
      }
      .cls-123 {
        fill: #ffde69;
      }
      .cls-124 {
        fill: #ffe071;
      }
      .cls-125 {
        fill: #ffe072;
      }
      .cls-126 {
        fill: #ffdd63;
      }
      .cls-127 {
        fill: #ffdd67;
      }
      .cls-128 {
        fill: #ffdd65;
      }
      .cls-129 {
        fill: #ffdd64;
      }
      .cls-130 {
        fill: #ffde6a;
      }
      .cls-131 {
        fill: #fd6;
      }
      .cls-132 {
        fill: #ffe073;
      }
      .cls-133 {
        fill: #ffe074;
      }
    `}
  >
    <defs>
      <style></style>
      <clipPath id='clippath'>
        <path
          className='cls-2'
          d='M306.61,200.25l24.12,48.86c.58,1.17,1.7,1.99,2.99,2.17l53.92,7.84c3.26.47,4.56,4.48,2.2,6.78l-39.02,38.03c-.94.91-1.36,2.23-1.14,3.52l9.21,53.71c.56,3.25-2.85,5.72-5.77,4.19l-48.23-25.36c-1.16-.61-2.54-.61-3.7,0l-48.23,25.36c-2.92,1.53-6.32-.94-5.77-4.19l9.21-53.71c.22-1.29-.21-2.6-1.14-3.52l-39.02-38.03c-2.36-2.3-1.06-6.31,2.2-6.78l53.92-7.84c1.29-.19,2.41-1,2.99-2.17l24.12-48.86c1.46-2.95,5.67-2.95,7.13,0Z'
        />
      </clipPath>
      <clipPath id='clippath-1'>
        <path
          className='cls-2'
          d='M327.27,293.56c9.79,0,17.73-7.94,17.73-17.73h-35.46c0,9.79,7.94,17.73,17.73,17.73Z'
        />
      </clipPath>
      <clipPath id='clippath-2'>
        <path
          className='cls-2'
          d='M279.09,293.56c9.79,0,17.73-7.94,17.73-17.73h-35.46c0,9.79,7.94,17.73,17.73,17.73Z'
        />
      </clipPath>
    </defs>
    <circle className='cls-2' cx='46.42' cy='441.88' r='17.58' />
    <g>
      <circle className='cls-120' cx='303.04' cy='287.67' r='162.5' />
      <path
        className='cls-4'
        d='M243.45,404.25l-15.13-10.89c-9.34-6.75-13.96-18-12.04-29.36l8.25-48.13-48.23-47.01,5.7-17.77c3.54-10.97,12.82-18.82,24.22-20.5l48.3-7.02,21.55-43.67,8.14-16.67,18.69-.12h.15c11.46,0,21.75,6.36,26.88,16.61l.07.14,21.57,43.71,66.73,9.7,5.79,17.82c3.54,10.97.6,22.77-7.67,30.8l-34.86,33.98,11.4,66.49-15.19,11.01c-9.34,6.75-21.47,7.59-31.66,2.2l-43.07-22.64-59.6,31.33ZM232.06,342.45c-.05.03-.1.06-.16.08l.16-.08ZM277.42,283.64l11.45,10.63-2.54,16.23-.65,3.76,3.18-1.67,13.95-7.61,17.6,9.28-.71-4.15-2.44-15.44,13.88-13.43-4.14-.6-15.47-2.44-8.49-17.37-1.65,3.35-6.76,13.92-15.91,2.6-3.78.55,2.47,2.41ZM231.46,238.84l.08.08s-.06-.05-.08-.08Z'
      />
      <path
        className='cls-5'
        d='M251.1,375.82c-2.89,0-5.75-.9-8.2-2.68-4.33-3.15-6.47-8.39-5.56-13.67l8.67-50.59-36.75-35.82c-3.84-3.74-5.19-9.23-3.54-14.32,1.66-5.1,5.98-8.74,11.28-9.51l50.79-7.38,22.71-46.02c2.37-4.8,7.17-7.79,12.53-7.79s10.16,2.99,12.53,7.79l22.71,46.02,50.79,7.38c5.3.77,9.62,4.41,11.28,9.51,1.66,5.1.3,10.58-3.54,14.33l-36.75,35.82,8.67,50.59c.91,5.28-1.22,10.52-5.56,13.67-4.33,3.15-9.97,3.56-14.72,1.06l-45.43-23.88-45.43,23.88c-2.06,1.08-4.29,1.62-6.52,1.62ZM231.97,267.26l30.28,29.51c3.29,3.21,4.8,7.83,4.02,12.37l-7.15,41.68,37.42-19.68c4.07-2.14,8.93-2.14,13.01,0l37.42,19.67-7.15-41.67c-.78-4.53.72-9.16,4.02-12.37l30.27-29.51-41.84-6.08c-4.55-.66-8.49-3.52-10.52-7.65l-18.71-37.91-18.71,37.92c-2.04,4.12-5.97,6.98-10.52,7.64l-41.84,6.08ZM297.64,204.67s0,0,0,0h0Z'
      />
      <g className='cls-1'>
        <rect className='cls-17' x='213.89' y='197.29' width='178.31' height='4.35' />
        <rect className='cls-17' x='213.89' y='201.65' width='178.31' height='1.08' />
        <rect className='cls-18' x='213.89' y='202.73' width='178.31' height='1.08' />
        <rect className='cls-11' x='213.89' y='203.81' width='178.31' height='1.08' />
        <rect className='cls-20' x='213.89' y='204.9' width='178.31' height='1.08' />
        <rect className='cls-22' x='213.89' y='205.98' width='178.31' height='1.08' />
        <rect className='cls-23' x='213.89' y='207.07' width='178.31' height='1.08' />
        <rect className='cls-21' x='213.89' y='208.15' width='178.31' height='1.08' />
        <rect className='cls-29' x='213.89' y='209.23' width='178.31' height='1.08' />
        <rect className='cls-28' x='213.89' y='210.32' width='178.31' height='1.08' />
        <rect className='cls-30' x='213.89' y='211.4' width='178.31' height='1.08' />
        <rect className='cls-32' x='213.89' y='212.48' width='178.31' height='1.08' />
        <rect className='cls-31' x='213.89' y='213.57' width='178.31' height='1.08' />
        <rect className='cls-133' x='213.89' y='214.65' width='178.31' height='1.08' />
        <rect className='cls-132' x='213.89' y='215.74' width='178.31' height='1.08' />
        <rect className='cls-125' x='213.89' y='216.82' width='178.31' height='1.08' />
        <rect className='cls-124' x='213.89' y='217.9' width='178.31' height='1.08' />
        <rect className='cls-40' x='213.89' y='218.99' width='178.31' height='1.08' />
        <rect className='cls-37' x='213.89' y='220.07' width='178.31' height='1.08' />
        <rect className='cls-39' x='213.89' y='221.16' width='178.31' height='1.08' />
        <rect className='cls-36' x='213.89' y='222.24' width='178.31' height='1.08' />
        <rect className='cls-38' x='213.89' y='223.32' width='178.31' height='1.08' />
        <rect className='cls-121' x='213.89' y='224.41' width='178.31' height='1.08' />
        <rect className='cls-130' x='213.89' y='225.49' width='178.31' height='1.08' />
        <rect className='cls-123' x='213.89' y='226.58' width='178.31' height='1.08' />
        <rect className='cls-122' x='213.89' y='227.66' width='178.31' height='1.08' />
        <rect className='cls-127' x='213.89' y='228.74' width='178.31' height='1.08' />
        <rect className='cls-131' x='213.89' y='229.83' width='178.31' height='1.08' />
        <rect className='cls-128' x='213.89' y='230.91' width='178.31' height='1.08' />
        <rect className='cls-129' x='213.89' y='232' width='178.31' height='1.08' />
        <rect className='cls-126' x='213.89' y='233.08' width='178.31' height='1.08' />
        <rect className='cls-15' x='213.89' y='234.16' width='178.31' height='1.08' />
        <rect className='cls-14' x='213.89' y='235.25' width='178.31' height='1.08' />
        <rect className='cls-13' x='213.89' y='236.33' width='178.31' height='1.08' />
        <rect className='cls-12' x='213.89' y='237.41' width='178.31' height='1.08' />
        <rect className='cls-16' x='213.89' y='238.5' width='178.31' height='1.08' />
        <rect className='cls-27' x='213.89' y='239.58' width='178.31' height='1.08' />
        <rect className='cls-25' x='213.89' y='240.67' width='178.31' height='1.08' />
        <rect className='cls-24' x='213.89' y='241.75' width='178.31' height='1.08' />
        <rect className='cls-26' x='213.89' y='242.83' width='178.31' height='1.08' />
        <rect className='cls-42' x='213.89' y='243.92' width='178.31' height='1.08' />
        <rect className='cls-33' x='213.89' y='245' width='178.31' height='1.08' />
        <rect className='cls-41' x='213.89' y='246.09' width='178.31' height='1.08' />
        <rect className='cls-35' x='213.89' y='247.17' width='178.31' height='1.08' />
        <rect className='cls-34' x='213.89' y='248.25' width='178.31' height='1.08' />
        <rect className='cls-44' x='213.89' y='249.34' width='178.31' height='1.08' />
        <rect className='cls-43' x='213.89' y='250.42' width='178.31' height='1.08' />
        <rect className='cls-46' x='213.89' y='251.51' width='178.31' height='1.08' />
        <rect className='cls-45' x='213.89' y='252.59' width='178.31' height='1.08' />
        <rect className='cls-113' x='213.89' y='253.67' width='178.31' height='1.08' />
        <rect className='cls-112' x='213.89' y='254.76' width='178.31' height='1.08' />
        <rect className='cls-117' x='213.89' y='255.84' width='178.31' height='1.08' />
        <rect className='cls-90' x='213.89' y='256.93' width='178.31' height='1.08' />
        <rect className='cls-88' x='213.89' y='258.01' width='178.31' height='1.08' />
        <rect className='cls-105' x='213.89' y='259.09' width='178.31' height='1.08' />
        <rect className='cls-106' x='213.89' y='260.18' width='178.31' height='1.08' />
        <rect className='cls-107' x='213.89' y='261.26' width='178.31' height='1.08' />
        <rect className='cls-104' x='213.89' y='262.34' width='178.31' height='1.08' />
        <rect className='cls-73' x='213.89' y='263.43' width='178.31' height='1.08' />
        <rect className='cls-74' x='213.89' y='264.51' width='178.31' height='1.08' />
        <rect className='cls-76' x='213.89' y='265.6' width='178.31' height='1.08' />
        <rect className='cls-81' x='213.89' y='266.68' width='178.31' height='1.08' />
        <rect className='cls-75' x='213.89' y='267.76' width='178.31' height='1.08' />
        <rect className='cls-98' x='213.89' y='268.85' width='178.31' height='1.08' />
        <rect className='cls-97' x='213.89' y='269.93' width='178.31' height='1.08' />
        <rect className='cls-91' x='213.89' y='271.02' width='178.31' height='1.08' />
        <rect className='cls-92' x='213.89' y='272.1' width='178.31' height='1.08' />
        <rect className='cls-93' x='213.89' y='273.18' width='178.31' height='1.08' />
        <rect className='cls-103' x='213.89' y='274.27' width='178.31' height='1.08' />
        <rect className='cls-94' x='213.89' y='275.35' width='178.31' height='1.08' />
        <rect className='cls-118' x='213.89' y='276.44' width='178.31' height='1.08' />
        <rect className='cls-119' x='213.89' y='277.52' width='178.31' height='1.08' />
        <rect className='cls-61' x='213.89' y='278.6' width='178.31' height='1.08' />
        <rect className='cls-60' x='213.89' y='279.69' width='178.31' height='1.08' />
        <rect className='cls-62' x='213.89' y='280.77' width='178.31' height='1.08' />
        <rect className='cls-59' x='213.89' y='281.86' width='178.31' height='1.08' />
        <rect className='cls-71' x='213.89' y='282.94' width='178.31' height='1.08' />
        <rect className='cls-72' x='213.89' y='284.02' width='178.31' height='1.08' />
        <rect className='cls-58' x='213.89' y='285.11' width='178.31' height='1.08' />
        <rect className='cls-57' x='213.89' y='286.19' width='178.31' height='1.08' />
        <rect className='cls-56' x='213.89' y='287.27' width='178.31' height='1.08' />
        <rect className='cls-63' x='213.89' y='288.36' width='178.31' height='1.08' />
        <rect className='cls-64' x='213.89' y='289.44' width='178.31' height='1.08' />
        <rect className='cls-65' x='213.89' y='290.53' width='178.31' height='1.08' />
        <rect className='cls-66' x='213.89' y='291.61' width='178.31' height='1.08' />
        <rect className='cls-47' x='213.89' y='292.69' width='178.31' height='1.08' />
        <rect className='cls-50' x='213.89' y='293.78' width='178.31' height='1.08' />
        <rect className='cls-51' x='213.89' y='294.86' width='178.31' height='1.08' />
        <rect className='cls-49' x='213.89' y='295.95' width='178.31' height='1.08' />
        <rect className='cls-48' x='213.89' y='297.03' width='178.31' height='1.08' />
        <rect className='cls-55' x='213.89' y='298.11' width='178.31' height='1.08' />
        <rect className='cls-54' x='213.89' y='299.2' width='178.31' height='1.08' />
        <rect className='cls-53' x='213.89' y='300.28' width='178.31' height='1.08' />
        <rect className='cls-52' x='213.89' y='301.37' width='178.31' height='1.08' />
        <rect className='cls-84' x='213.89' y='302.45' width='178.31' height='1.08' />
        <rect className='cls-108' x='213.89' y='303.53' width='178.31' height='1.08' />
        <rect className='cls-109' x='213.89' y='304.62' width='178.31' height='1.08' />
        <rect className='cls-83' x='213.89' y='305.7' width='178.31' height='1.08' />
        <rect className='cls-82' x='213.89' y='306.79' width='178.31' height='1.08' />
        <rect className='cls-95' x='213.89' y='307.87' width='178.31' height='1.08' />
        <rect className='cls-96' x='213.89' y='308.95' width='178.31' height='1.08' />
        <rect className='cls-86' x='213.89' y='310.04' width='178.31' height='1.08' />
        <rect className='cls-87' x='213.89' y='311.12' width='178.31' height='1.08' />
        <rect className='cls-85' x='213.89' y='312.21' width='178.31' height='1.08' />
        <rect className='cls-116' x='213.89' y='313.29' width='178.31' height='1.08' />
        <rect className='cls-115' x='213.89' y='314.37' width='178.31' height='1.08' />
        <rect className='cls-111' x='213.89' y='315.46' width='178.31' height='1.08' />
        <rect className='cls-99' x='213.89' y='316.54' width='178.31' height='1.08' />
        <rect className='cls-9' x='213.89' y='317.62' width='178.31' height='1.08' />
        <rect className='cls-6' x='213.89' y='318.71' width='178.31' height='1.08' />
        <rect className='cls-8' x='213.89' y='319.79' width='178.31' height='1.08' />
        <rect className='cls-7' x='213.89' y='320.88' width='178.31' height='1.08' />
        <rect className='cls-10' x='213.89' y='321.96' width='178.31' height='1.08' />
        <rect className='cls-78' x='213.89' y='323.04' width='178.31' height='1.08' />
        <rect className='cls-79' x='213.89' y='324.13' width='178.31' height='1.08' />
        <rect className='cls-80' x='213.89' y='325.21' width='178.31' height='1.08' />
        <rect className='cls-77' x='213.89' y='326.3' width='178.31' height='1.08' />
        <rect className='cls-112' x='213.89' y='327.38' width='178.31' height='1.08' />
        <rect className='cls-113' x='213.89' y='328.46' width='178.31' height='1.08' />
        <rect className='cls-110' x='213.89' y='329.55' width='178.31' height='1.08' />
        <rect className='cls-114' x='213.89' y='330.63' width='178.31' height='1.08' />
        <rect className='cls-89' x='213.89' y='331.72' width='178.31' height='1.08' />
        <rect className='cls-68' x='213.89' y='332.8' width='178.31' height='1.08' />
        <rect className='cls-69' x='213.89' y='333.88' width='178.31' height='1.08' />
        <rect className='cls-67' x='213.89' y='334.97' width='178.31' height='1.08' />
        <rect className='cls-70' x='213.89' y='336.05' width='178.31' height='1.08' />
        <rect className='cls-100' x='213.89' y='337.14' width='178.31' height='1.08' />
        <rect className='cls-102' x='213.89' y='338.22' width='178.31' height='1.08' />
        <rect className='cls-101' x='213.89' y='339.3' width='178.31' height='1.08' />
        <rect className='cls-101' x='213.89' y='340.39' width='178.31' height='26.5' />
      </g>
      <g>
        <path
          className='cls-101'
          d='M213.28,208.72h0c0-10.44-8.46-18.9-18.9-18.9h0c10.44,0,18.9-8.46,18.9-18.9h0c0,10.44,8.46,18.9,18.9,18.9h0c-10.44,0-18.9,8.46-18.9,18.9Z'
        />
        <path
          className='cls-101'
          d='M213.28,210.35c-.9,0-1.63-.73-1.63-1.63,0-9.52-7.74-17.27-17.27-17.27-.9,0-1.63-.73-1.63-1.63s.73-1.63,1.63-1.63c9.52,0,17.27-7.74,17.27-17.27,0-.9.73-1.63,1.63-1.63s1.63.73,1.63,1.63c0,9.52,7.74,17.27,17.27,17.27.9,0,1.63.73,1.63,1.63s-.73,1.63-1.63,1.63c-9.52,0-17.27,7.74-17.27,17.27,0,.9-.73,1.63-1.63,1.63ZM202.41,189.82c4.88,2.08,8.8,6,10.87,10.87,2.08-4.88,6-8.8,10.87-10.87-4.88-2.08-8.8-6-10.87-10.87-2.08,4.88-6,8.8-10.87,10.87Z'
        />
      </g>
      <g>
        <path
          className='cls-5'
          d='M403.55,174.14h0c0-10.44-8.46-18.9-18.9-18.9h0c10.44,0,18.9-8.46,18.9-18.9h0c0,10.44,8.46,18.9,18.9,18.9h0c-10.44,0-18.9,8.46-18.9,18.9Z'
        />
        <path
          className='cls-5'
          d='M403.55,175.78c-.9,0-1.63-.73-1.63-1.63,0-9.52-7.74-17.27-17.27-17.27-.9,0-1.63-.73-1.63-1.63s.73-1.63,1.63-1.63c9.52,0,17.27-7.74,17.27-17.27,0-.9.73-1.63,1.63-1.63s1.63.73,1.63,1.63c0,9.52,7.74,17.27,17.27,17.27.9,0,1.63.73,1.63,1.63s-.73,1.63-1.63,1.63c-9.52,0-17.27,7.74-17.27,17.27,0,.9-.73,1.63-1.63,1.63ZM392.68,155.24c4.88,2.08,8.8,6,10.87,10.87,2.08-4.88,6-8.8,10.87-10.87-4.88-2.08-8.8-6-10.87-10.87-2.08,4.88-6,8.8-10.87,10.87Z'
        />
      </g>
      <g>
        <path
          className='cls-19'
          d='M368.29,192.71h0c0-6.1-4.95-11.05-11.05-11.05h0c6.1,0,11.05-4.95,11.05-11.05h0c0,6.1,4.95,11.05,11.05,11.05h0c-6.1,0-11.05,4.95-11.05,11.05Z'
        />
        <path
          className='cls-19'
          d='M368.29,193.67c-.53,0-.96-.43-.96-.96,0-5.57-4.53-10.1-10.09-10.1-.53,0-.96-.43-.96-.96s.43-.96.96-.96c5.57,0,10.09-4.53,10.09-10.09,0-.53.43-.96.96-.96s.96.43.96.96c0,5.57,4.53,10.09,10.09,10.09.53,0,.96.43.96.96s-.43.96-.96.96c-5.57,0-10.09,4.53-10.09,10.1,0,.53-.43.96-.96.96ZM361.93,181.66c2.85,1.22,5.14,3.51,6.36,6.36,1.22-2.85,3.51-5.14,6.36-6.36-2.85-1.22-5.14-3.5-6.36-6.36-1.22,2.85-3.51,5.14-6.36,6.36Z'
        />
      </g>
      <g>
        <path
          className='cls-5'
          d='M418.72,358.86h0c0-6.1-4.95-11.05-11.05-11.05h0c6.1,0,11.05-4.95,11.05-11.05h0c0,6.1,4.95,11.05,11.05,11.05h0c-6.1,0-11.05,4.95-11.05,11.05Z'
        />
        <path
          className='cls-5'
          d='M418.72,359.82c-.53,0-.96-.43-.96-.96,0-5.57-4.53-10.1-10.09-10.1-.53,0-.96-.43-.96-.96s.43-.96.96-.96c5.57,0,10.09-4.53,10.09-10.09,0-.53.43-.96.96-.96s.96.43.96.96c0,5.57,4.53,10.09,10.09,10.09.53,0,.96.43.96.96s-.43.96-.96.96c-5.57,0-10.09,4.53-10.09,10.1,0,.53-.43.96-.96.96ZM412.36,347.81c2.85,1.22,5.14,3.51,6.36,6.36,1.22-2.85,3.51-5.14,6.36-6.36-2.85-1.22-5.14-3.5-6.36-6.36-1.22,2.85-3.51,5.14-6.36,6.36Z'
        />
      </g>
      <g>
        <path
          className='cls-5'
          d='M174.47,329.54h0c0-6.1-4.95-11.05-11.05-11.05h0c6.1,0,11.05-4.95,11.05-11.05h0c0,6.1,4.95,11.05,11.05,11.05h0c-6.1,0-11.05,4.95-11.05,11.05Z'
        />
        <path
          className='cls-5'
          d='M174.47,330.49c-.53,0-.96-.43-.96-.96,0-5.57-4.53-10.1-10.09-10.1-.53,0-.96-.43-.96-.96s.43-.96.96-.96c5.57,0,10.09-4.53,10.09-10.09,0-.53.43-.96.96-.96s.96.43.96.96c0,5.57,4.53,10.09,10.09,10.09.53,0,.96.43.96.96s-.43.96-.96.96c-5.57,0-10.09,4.53-10.09,10.1,0,.53-.43.96-.96.96ZM168.11,318.49c2.85,1.22,5.14,3.51,6.36,6.36,1.22-2.85,3.51-5.14,6.36-6.36-2.85-1.22-5.14-3.5-6.36-6.36-1.22,2.85-3.51,5.14-6.36,6.36Z'
        />
      </g>
      <g>
        <path
          className='cls-3'
          d='M303.04,311.15h-.05c-5.03-.02-9.67-2.97-11.81-7.51-.39-.82-.04-1.8.78-2.19.82-.39,1.8-.04,2.19.78,1.61,3.41,5.08,5.62,8.86,5.63h.03c3.8,0,7.29-2.21,8.91-5.63.39-.82,1.36-1.17,2.19-.78.82.39,1.17,1.37.78,2.19-2.16,4.57-6.82,7.51-11.88,7.51Z'
        />
        <g>
          <path
            className='cls-3'
            d='M279.09,293.56c9.79,0,17.73-7.94,17.73-17.73h-35.46c0,9.79,7.94,17.73,17.73,17.73Z'
          />
          <path
            className='cls-3'
            d='M327.27,293.56c9.79,0,17.73-7.94,17.73-17.73h-35.46c0,9.79,7.94,17.73,17.73,17.73Z'
          />
          <g className='cls-134'>
            <rect
              className='cls-120'
              x='309.38'
              y='278.44'
              width='28.08'
              height='4.6'
              transform='translate(-103.79 310.92) rotate(-45)'
            />
            <rect
              className='cls-120'
              x='310.86'
              y='282.39'
              width='35.99'
              height='2.3'
              transform='translate(-104.17 315.59) rotate(-45)'
            />
          </g>
          <g className='cls-135'>
            <rect
              className='cls-120'
              x='261.2'
              y='278.44'
              width='28.08'
              height='4.6'
              transform='translate(-117.9 276.85) rotate(-45)'
            />
            <rect
              className='cls-120'
              x='262.69'
              y='282.39'
              width='35.99'
              height='2.3'
              transform='translate(-118.28 281.52) rotate(-45)'
            />
          </g>
          <path
            className='cls-3'
            d='M349.23,276.47h-92.38c-1.27,0-2.3-1.03-2.3-2.3s1.03-2.3,2.3-2.3h92.38c1.27,0,2.3,1.03,2.3,2.3s-1.03,2.3-2.3,2.3Z'
          />
        </g>
      </g>
    </g>
  </svg>
);
